module.exports = __webpack_public_path__ + "static/media/work2.42fe47c9.jpg";